import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import '../App.css';
import './CommunityPage.css';

const formatBoardDate = (item) => {
  if (item.boardReviewedAt?.toDate) {
    return item.boardReviewedAt.toDate().toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric',
    });
  }
  return 'Previously brought before the board';
};

function CommunityPage() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Board Follow-ups | Hidden Creek';
    const loadPublished = async () => {
      try {
        const publishedQuery = query(collection(db, 'submissions'), where('publicationStatus', '==', 'published'));
        const snapshot = await getDocs(publishedQuery);
        const loaded = snapshot.docs
          .map((entry) => ({ id: entry.id, ...entry.data() }))
          .sort((a, b) => (b.boardReviewedAt?.toMillis?.() || 0) - (a.boardReviewedAt?.toMillis?.() || 0));
        setSubmissions(loaded);
      } catch (loadError) {
        console.error('Unable to load board follow-ups:', loadError);
        setError('Board follow-ups are temporarily unavailable. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    loadPublished();
  }, []);

  return (
    <div className="community-shell">
      <header className="site-header">
        <a className="brand" href="/"><span className="brand-mark" aria-hidden="true">HC</span><span><strong>Hidden Creek</strong><small>of Sebring Homeowners Association</small></span></a>
        <nav aria-label="Community navigation"><a href="/">Submit feedback</a><a className="nav-cta" href="/community">Board follow-ups</a></nav>
      </header>
      <main>
        <section className="community-hero">
          <p className="eyebrow">Public community record</p>
          <h1>Topics brought <em>before the board.</em></h1>
          <p>This page shares anonymous questions and feedback only after the topic has been raised with the HOA board. It is a read-only record, not a public comment forum.</p>
        </section>
        <section className="community-records" aria-labelledby="records-title">
          <div className="community-records-heading">
            <div><p className="eyebrow">Board follow-ups</p><h2 id="records-title">Community topics on record.</h2></div>
            <span>{submissions.length} {submissions.length === 1 ? 'topic' : 'topics'}</span>
          </div>
          {loading && <p className="community-state">Loading board follow-ups…</p>}
          {error && <p className="community-state community-error" role="alert">{error}</p>}
          {!loading && !error && submissions.length === 0 && <div className="community-empty"><span aria-hidden="true">HC</span><h3>No public follow-ups yet.</h3><p>Topics will appear here after they have been brought before the board.</p><a href="/">Share anonymous feedback →</a></div>}
          <div className="community-record-list">
            {submissions.map((item, index) => <article className="community-record" key={item.id}>
              <div className="community-record-number">{String(index + 1).padStart(2, '0')}</div>
              <div className="community-record-body">
                <div className="community-record-meta"><span>{item.feedbackType || 'Community feedback'}</span><time>{formatBoardDate(item)}</time></div>
                <p>{item.feedbacktext}</p>
                <div className="community-record-status"><span aria-hidden="true">✓</span> Brought before the board</div>
              </div>
            </article>)}
          </div>
        </section>
      </main>
      <footer>
        <a className="brand footer-brand" href="/"><span className="brand-mark" aria-hidden="true">HC</span><span><strong>Hidden Creek</strong><small>of Sebring Homeowners Association</small></span></a>
        <p>Transparent follow-up for a stronger community.</p><a href="/">Share your voice ↑</a>
      </footer>
    </div>
  );
}

export default CommunityPage;
